import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import financial from "../src/assets/Financial.jpg";
import "./Menu1.css";

const financialDetails = [
  { year: "2016-17", members: "24444", shareCapital: "519.65", deposits: "14404.94", loans: "12334.99", reserves: "748.46", netProfit: "275.89", dividend: "13" },
  { year: "2017-18", members: "27192", shareCapital: "659.48", deposits: "16117.17", loans: "11136.61", reserves: "957.79", netProfit: "304.03", dividend: "13" },
  { year: "2018-19", members: "30371", shareCapital: "813.28", deposits: "17827.68", loans: "13010.99", reserves: "1149.99", netProfit: "351.01", dividend: "13" },
  { year: "2019-20", members: "33118", shareCapital: "977.30", deposits: "19672.32", loans: "15578.22", reserves: "1370.21", netProfit: "195.86", dividend: "8.5" },
  { year: "2020-21", members: "34784", shareCapital: "951.07", deposits: "21009.22", loans: "15873.65", reserves: "1471.55", netProfit: "375.05", dividend: "10" },
  { year: "2021-22", members: "36353", shareCapital: "964.92", deposits: "22687.17", loans: "17910.48", reserves: "1727.83", netProfit: "447.86", dividend: "10" },
  { year: "2022-23", members: "40075", shareCapital: "981.65", deposits: "25656.30", loans: "22797.62", reserves: "2043.30", netProfit: "515.10", dividend: "12" },
  { year: "2023-24", members: "45077", shareCapital: "975.47", deposits: "31629.71", loans: "28659.76", reserves: "2405.57", netProfit: "519.27", dividend: "12" },
  { year: "2024-25", members: "49257", shareCapital: "990.00", deposits: "35800.00", loans: "33000.00", reserves: "2758.89", netProfit: "599.00", dividend: "13" },
  { year: "2025-26", members: "52431", shareCapital: "1029.00", deposits: "41400.00", loans: "38700.00", reserves: "3203.39", netProfit: "727.00", dividend: "-" },
];

const FinancialDetailsCard = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Responsive styles
  const mainContainerStyle = {
    background: "linear-gradient(90deg, #fff, #cb71ca)",
    minHeight: isMobile ? "auto" : "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: isMobile ? "flex-start" : "center",
    padding: isMobile ? "5px" : "5px",
  };

  const contentWrapperStyle = {
    width: "100%",
    maxWidth: isMobile ? "100%" : "1200px",
  };

  const headerStyle = {
    textAlign: "left",
    marginBottom: isMobile ? "10px" : "10px",
    fontSize: isMobile ? "18px" : "22px",
    fontWeight: "bold",
    color: "#700d69",
  };

  const tableContainerStyle = {
    width: "100%",
    maxWidth: isMobile ? "98%" : "1200px",
    minWidth: isMobile ? "100%" : "300px",
    padding: isMobile ? "10px" : "15px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    borderRadius: "10px",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#fff",
    margin: isMobile ? "0 auto" : "0",
  };

  const tableTitleStyle = {
    textAlign: "center",
    marginBottom: isMobile ? "15px" : "20px",
    fontSize: isMobile ? "14px" : "22px",
    fontWeight: "bold",
    color: "#700d69",
    lineHeight: isMobile ? "1.3" : "1.4",
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: isMobile ? "10px" : "14px",
  };

  const thStyle = {
    padding: isMobile ? "6px 3px" : "10px",
    border: "1px solid #ddd",
    backgroundColor: "#700d69",
    color: "#fff",
    textAlign: "left",
    fontSize: isMobile ? "9px" : "14px",
    wordBreak: isMobile ? "break-word" : "normal",
  };

  const tdStyle = (index) => ({
    padding: isMobile ? "6px 3px" : "10px",
    border: "1px solid #ddd",
    backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
    fontSize: isMobile ? "9px" : "14px",
    wordBreak: isMobile ? "break-word" : "normal",
  });

  const bannerImageStyle = {
    width: "100%",
    height: isMobile ? "180px" : "340px",
    objectFit: "cover",
  };

  return (
    <div>
      <Navbar />
      
      {/* Mobile Menu Toggle Button */}
      {isMobile && (
        <div className="mobile-menu-toggle" onClick={toggleSidebar}>
          <div className={`hamburger ${sidebarOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      {/* Overlay for mobile */}
      {isMobile && sidebarOpen && (
        <div className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`} onClick={closeSidebar}></div>
      )}

      <div className={`small-container ${isMobile ? 'mobile' : ''}`} style={{gap: isMobile ? "0px" : "5px"}}>
        {/* Sidebar */}
        <div className={`small-sidebar ${isMobile ? (sidebarOpen ? 'mobile-open' : 'mobile-closed') : ''}`}>
          {/* Top wave */}
          <div className="sidebar-wave-top"></div>
          <ul>
            <li>
              <a href="presidents_message" onClick={isMobile ? closeSidebar : undefined}>President's Message</a>
            </li>
            <li><a href="documents" onClick={isMobile ? closeSidebar : undefined}>Annual Report</a></li>
            <li><a href="interest" onClick={isMobile ? closeSidebar : undefined}>Interest Rate</a></li>
            <li><a href="loans" onClick={isMobile ? closeSidebar : undefined}>Loans</a></li>
            <li><a href="awards" onClick={isMobile ? closeSidebar : undefined}>Awards</a></li>
          </ul>
          {/* Bottom wave */}
          <div className="sidebar-wave"></div>
        </div>

        {/* Content Section */}
        <div className="small-content">
          <div className="image-wrapper">
            <img src={financial} alt="About Us" style={bannerImageStyle} />
          </div>
        </div>
      </div>

      <div style={mainContainerStyle}>
        <div style={contentWrapperStyle}>
          <h1 style={headerStyle}>
            Financial Details
          </h1>

          <div style={tableContainerStyle}>
            <h5 style={tableTitleStyle}>
              THE BIRD EYE VIEW OF PROGRESS OF THE SAHAKARI. Progress Details report as on 31-03-2025(2024-25) Rupees in lakhs.
            </h5>
            
            <div style={{ overflowX: isMobile ? "auto" : "visible", overflowY: "visible" }}>
              <table style={tableStyle}>
                <thead>
                  <tr style={{ backgroundColor: "#700d69", color: "#fff", textAlign: "left" }}>
                    <th style={thStyle}>Year</th>
                    <th style={thStyle}>Members</th>
                    <th style={thStyle}>Share Capital</th>
                    <th style={thStyle}>Deposits</th>
                    <th style={thStyle}>Loans</th>
                    <th style={thStyle}>Reserves</th>
                    <th style={thStyle}>Net Profit</th>
                    <th style={thStyle}>Dividend (%)</th>
                  </tr>
                </thead>
                <tbody>
                  {financialDetails.map((item, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff" }}>
                      <td style={tdStyle(index)}>{item.year}</td>
                      <td style={tdStyle(index)}>{item.members}</td>
                      <td style={tdStyle(index)}>{item.shareCapital}</td>
                      <td style={tdStyle(index)}>{item.deposits}</td>
                      <td style={tdStyle(index)}>{item.loans}</td>
                      <td style={tdStyle(index)}>{item.reserves}</td>
                      <td style={tdStyle(index)}>{item.netProfit}</td>
                      <td style={tdStyle(index)}>{item.dividend}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FinancialDetailsCard;